import React, { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import MainAsideMenuLayout from "../../../../components/layouts/mainAsideMenuLayout/MainAsideMenuLayout";
import List from "../../../../components/elements/list/List";
import ItemList from "../../../../components/elements/itemList/ItemList";
import HeaderDashboardLayout from "../../../../components/layouts/headerDashboardLayout/HeaderDashboardLayout";

import st from "./styles.module.scss";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import { Rotate } from "../../../../types/baseType";
import Tx from "../../../../types/naming";
import ExpensesByMonthDashboard, {
    expensesDetalizationSelector
} from "./month";
import { CropSelectorProps } from "../../phases";
import { array } from "fp-ts";
import { ExpensesDetalizationData } from "../../../../store/reducers/dashboard/expenses/detalization";
import { withLayout } from "../../DashboardPage";

interface ExpensesDetailedPageProps extends CropSelectorProps {
}

const ExpensesDetailedPage: FC<ExpensesDetailedPageProps> = () => {
    let { data } = useTypedSelector(expensesDetalizationSelector);

    const [activeCategory, setActiveCategory] = useState<ExpensesDetalizationData>();

    useEffect(() => {
        if (array.isNonEmpty(data)) setActiveCategory(data[0])
    }, [data]);

    const onSelect = (title: string) => {
        const selectedCategory = data.find((item) => item.title === title);
        if (selectedCategory) {
            setActiveCategory(selectedCategory);
        }
    };

    return (
            <HeaderDashboardLayout title={Tx.ExpensesForMonth}>
                <List className={st.list} rotate={Rotate.Column}>
                    <ItemList className={st['list__item']}>
                        <ExpensesByMonthDashboard
                                onSelect={onSelect}
                                activeCategory={activeCategory}
                                categories={data}/>
                    </ItemList>
                </List>
            </HeaderDashboardLayout>
    );
};

export default withLayout(ExpensesDetailedPage);
